
/**
 * EmailJS sending helper functions
 */
import emailjs from 'emailjs-com';
import type { EmailJsConfig } from '../config/emailJsConfig';

/**
 * Initialize EmailJS with configuration
 */
export const initializeEmailJs = (config: EmailJsConfig): void => {
  emailjs.init(config.publicKey);
  
  console.log('EmailJS Configuration:', { 
    publicKey: config.publicKey, 
    serviceId: config.serviceId, 
    adminTemplateId: config.adminTemplateId, 
    customerTemplateId: config.customerTemplateId 
  });
};

/**
 * Type definition for EmailJS response status
 */
export interface EmailJSResponseStatus {
  status: number;
  text: string;
}

/**
 * Send email using EmailJS
 */
export const sendEmailWithEmailJs = async (
  serviceId: string, 
  templateId: string, 
  templateParams: Record<string, string>
): Promise<EmailJSResponseStatus> => {
  console.log(`Sending email with template: ${templateId}`);
  console.log('Template params:', JSON.stringify(templateParams));
  
  return await emailjs.send(serviceId, templateId, templateParams);
};
